import React from "react";

/**
 * @component AddCrossIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <AddCrossIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const AddCrossIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={10}
      height={10}
      viewBox="0 0 10 10"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="AddCrossIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path d="M6 0v4h4v2H6v4H4V6H0V4h4V0h2z" fillRule="nonzero" />
    </svg>
  )
);
AddCrossIcon.displayName = "AddCrossIcon";
export default AddCrossIcon;
